module.exports = __webpack_public_path__ + "img/logo_tass.eec0d58f.jpg";